module.exports = __webpack_public_path__ + "img/cleanRag.0d1e2149.png";